import {StateType} from './stateType';

export const getDefaultSections = (expectedPanels: StateType) => {
  const defaultSections = new Set<string>();
  if (expectedPanels) {
    const {defaultSpecs, apiAddedSpecs} = expectedPanels;
    for (const key in defaultSpecs) {
      defaultSections.add(defaultSpecs[key].defaultSection);
    }
    for (const key in apiAddedSpecs) {
      defaultSections.add(apiAddedSpecs[key].defaultSection);
    }
  }
  return defaultSections;
};

export const getExpectedSpec = (
  expectedPanels: StateType,
  key: string | null
) => {
  if (!expectedPanels) {
    return;
  }
  if (!key) {
    return;
  }
  return expectedPanels.defaultSpecs[key] ?? expectedPanels.apiAddedSpecs[key];
};
